var React = require('react');

function EmailIconLight (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Group 8"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("g",{"id":"Team-Popup","transform":"translate(-772.000000, -515.000000)"},React.createElement("g",{"id":"Group-8","transform":"translate(772.000000, 515.000000)"},[React.createElement("circle",{"id":"Oval-Copy-2","fill":"#EBF0F4","cx":"20","cy":"20","r":"20","key":0}),React.createElement("path",{"d":"M28,15.291 L20,22.318 L12,15.281 L12,15 L28,15 L28,15.291 Z M12,26 L12,17.945 L20,24.98 L28,17.953 L28,26 L12,26 Z M10,28 L30,28 L30,13 L10,13 L10,28 Z","id":"email-[#1573]","fill":"#365374","key":1})])))]);
}

EmailIconLight.defaultProps = {"width":"40px","height":"40px","viewBox":"0 0 40 40","version":"1.1"};

module.exports = EmailIconLight;

EmailIconLight.default = EmailIconLight;
